
import React from 'react';
import { useNavigate } from 'react-router-dom';

const comparisons = [
  { city: 'Austin, TX', path: '/usa/tx/austin', gross: 100000, federal: 12168, state: 0, local: 0, ss: 6200, med: 1450, net: 80182 },
  { city: 'Miami, FL', path: '/usa/fl/miami', gross: 100000, federal: 12168, state: 0, local: 0, ss: 6200, med: 1450, net: 80182 },
  { city: 'Seattle, WA', path: '/usa/wa/seattle', gross: 100000, federal: 12168, state: 0, local: 0, ss: 6200, med: 1450, net: 80182 },
  { city: 'Nashville, TN', path: '/usa/tn/nashville', gross: 100000, federal: 12168, state: 0, local: 0, ss: 6200, med: 1450, net: 80182 },
  { city: 'Denver, CO', path: '/usa/co/denver', gross: 100000, federal: 12168, state: 4400, local: 0, ss: 6200, med: 1450, net: 75782 },
  { city: 'Phoenix, AZ', path: '/usa/az/phoenix', gross: 100000, federal: 12168, state: 2500, local: 0, ss: 6200, med: 1450, net: 77682 },
  { city: 'Chicago, IL', path: '/usa/il/chicago', gross: 100000, federal: 12168, state: 4950, local: 0, ss: 6200, med: 1450, net: 75232 },
  { city: 'Boston, MA', path: '/usa/ma/boston', gross: 100000, federal: 12168, state: 5000, local: 0, ss: 6200, med: 1450, net: 75182 },
  { city: 'Manhattan, NY', path: '/usa/ny/manhattan', gross: 100000, federal: 12168, state: 5510, local: 3876, ss: 6200, med: 1450, net: 70796 },
  { city: 'San Francisco, CA', path: '/usa/ca/san-francisco', gross: 100000, federal: 12168, state: 5580, local: 0, ss: 6200, med: 1450, net: 74602 },
];

const TaxComparisonTable = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    try {
      navigate(path);
    } catch (err) {
      console.error('Navigation error:', err);
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            <strong>Take-Home Pay Comparison: $100K Salary Across US Cities</strong>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            See how much you actually keep from a $100,000 salary in different cities. State and local taxes make a huge difference in your paycheck.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="text-left px-5 py-4 font-semibold text-gray-700">City</th>
                  <th className="text-right px-5 py-4 font-semibold text-gray-700">Federal Tax</th>
                  <th className="text-right px-5 py-4 font-semibold text-gray-700">State Tax</th>
                  <th className="text-right px-5 py-4 font-semibold text-gray-700">FICA</th>
                  <th className="text-right px-5 py-4 font-semibold text-gray-700 bg-teal-50 text-teal-800">Take-Home Pay</th>
                  <th className="text-right px-5 py-4 font-semibold text-gray-700">Effective Rate</th>
                  <th className="px-5 py-4"></th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((row, i) => {
                  const totalTax = row.federal + row.state + row.local + row.ss + row.med;
                  const effectiveRate = ((totalTax / row.gross) * 100).toFixed(1);
                  return (
                    <tr
                      key={row.city}
                      className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${i % 2 === 0 ? '' : 'bg-gray-50/50'}`}
                    >
                      <td className="px-5 py-4">
                        <a
                          href={row.path}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigation(row.path);
                          }}
                          className="font-semibold text-gray-900 hover:text-teal-600 transition-colors cursor-pointer"
                        >
                          {row.city}
                        </a>
                      </td>
                      <td className="px-5 py-4 text-right text-gray-600">
                        ${row.federal.toLocaleString()}
                      </td>
                      <td className="px-5 py-4 text-right">
                        {row.state === 0 ? (
                          <span className="text-emerald-600 font-semibold">$0</span>
                        ) : (
                          <span className="text-gray-600">
                            ${(row.state + row.local).toLocaleString()}
                          </span>
                        )}
                      </td>
                      <td className="px-5 py-4 text-right text-gray-600">
                        ${(row.ss + row.med).toLocaleString()}
                      </td>
                      <td className="px-5 py-4 text-right bg-teal-50 font-bold text-teal-800">
                        ${row.net.toLocaleString()}
                      </td>
                      <td className="px-5 py-4 text-right">
                        <span
                          className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                            parseFloat(effectiveRate) < 20
                              ? 'bg-emerald-100 text-emerald-700'
                              : parseFloat(effectiveRate) < 25
                              ? 'bg-amber-100 text-amber-700'
                              : 'bg-red-100 text-red-700'
                          }`}
                        >
                          {effectiveRate}%
                        </span>
                      </td>
                      <td className="px-5 py-4 text-right">
                        <a
                          href={row.path}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigation(row.path);
                          }}
                          className="text-teal-600 hover:text-teal-700 cursor-pointer"
                        >
                          <i className="ri-arrow-right-line"></i>
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <p className="text-xs text-gray-400 text-center mt-4">
          Based on single filer, standard deduction, $100,000 gross salary. Actual results may vary
          based on individual circumstances.
          <strong> Last updated: January 2026.</strong>
        </p>
      </div>
    </section>
  );
};

export default TaxComparisonTable;
